import { render, staticRenderFns } from "./AzPersonsList.vue?vue&type=template&id=6c218add"
import script from "./AzPersonsList.vue?vue&type=script&lang=js"
export * from "./AzPersonsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports